import styled from "styled-components";
import media from "styled-media-query";
import { createGlobalStyle } from 'styled-components';

export const DrawerStyles = createGlobalStyle`
  .plugin-details-drawer {
    .ant-drawer-content-wrapper {
      box-shadow: 0 0 40px rgba(0, 0, 0, 0.15);
      transition: width 0.3s ease;
    }
    
    .ant-drawer-content {
      border-radius: 12px 0 0 12px;
      overflow: hidden;
    }
    
    &.fullscreen .ant-drawer-content {
      border-radius: 0;
    }
    
    .ant-drawer-body {
      padding: 0;
    }
    
    .ant-tabs-tab {
      padding: 12px 20px;
      font-size: 15px;
      transition: all 0.3s ease;
      
      &:hover {
        color: #0062cc;
      }
      
      &.ant-tabs-tab-active {
        font-weight: 600;
        
        .ant-tabs-tab-btn {
          color: #0062cc;
        }
      }
    }
    
    .ant-tabs-ink-bar {
      background: #0062cc;
      height: 3px;
      border-radius: 3px 3px 0 0;
    }
    
    .ant-tabs-nav-list {
      width: 100%;
      display: flex;
      justify-content: space-around;
    }
    
    .ant-tabs-content {
      height: calc(100vh - 350px);
      overflow-y: auto;
      
      &::-webkit-scrollbar {
        width: 8px;
      }
      
      &::-webkit-scrollbar-track {
        background: #f1f1f1;
      }
      
      &::-webkit-scrollbar-thumb {
        background: #c1c1c1;
        border-radius: 4px;
      }
      
      &::-webkit-scrollbar-thumb:hover {
        background: #a1a1a1;
      }
    }
    
    .ant-timeline-item-tail {
      border-left: 2px solid #e5e7eb;
    }
    
    .ant-timeline-item-head {
      width: 16px;
      height: 16px;
      margin-left: -8px;
    }
    
    .plugin-tabs {
      .ant-tabs-nav {
        padding: 0 20px;
        margin-bottom: 0;
        border-bottom: 1px solid #f0f0f0;
        background-color: #fff;
        position: sticky;
        top: 0;
        z-index: 10;
      }
      
      .ant-tabs-tab {
        padding: 15px 20px;
        font-size: 15px;
        transition: all 0.3s ease;
        margin: 0;
        
        &:hover {
          color: #0062cc;
        }
        
        &.ant-tabs-tab-active {
          font-weight: 600;
          
          .ant-tabs-tab-btn {
            color: #0062cc;
          }
        }
      }
      
      .ant-tabs-ink-bar {
        background: #0062cc;
        height: 3px;
        border-radius: 3px 3px 0 0;
      }
      
      .ant-tabs-nav-list {
        width: 100%;
        display: flex;
        justify-content: space-around;
      }
      
      .ant-tabs-content {
        height: calc(100vh - 350px);
        overflow-y: auto;
        
        &::-webkit-scrollbar {
          width: 8px;
        }
        
        &::-webkit-scrollbar-track {
          background: #f1f1f1;
        }
        
        &::-webkit-scrollbar-thumb {
          background: #c1c1c1;
          border-radius: 4px;
        }
        
        &::-webkit-scrollbar-thumb:hover {
          background: #a1a1a1;
        }
      }
      
      .tab-content {
        padding: 30px;
        color: #374151;
        font-size: 15px;
        line-height: 1.7;
        
        h2, h3, h4 {
          color: #111827;
          margin-top: 28px;
          margin-bottom: 16px;
          font-weight: 600;
          position: relative;
          padding-bottom: 8px;
          
          &::after {
            content: '';
            position: absolute;
            bottom: 0;
            left: 0;
            width: 40px;
            height: 3px;
            background: linear-gradient(90deg, #3454D1, #0891b2);
            border-radius: 2px;
          }
        }
        
        h2 {
          font-size: 22px;
        }
        
        h3 {
          font-size: 18px;
        }
        
        p {
          margin-bottom: 16px;
        }
        
        strong {
          font-weight: 600;
          color: #111827;
        }
        
        ul, ol {
          margin: 0 0 20px 0;
          padding-left: 24px;
          
          li {
            margin-bottom: 10px;
            position: relative;
            
            &::marker {
              color: #0062cc;
            }
          }
        }
        
        img {
          max-width: 100%;
          height: auto;
          border-radius: 8px;
          margin: 20px 0;
          box-shadow: 0 4px 20px rgba(0, 0, 0, 0.06);
          transition: transform 0.3s ease;
          
          &:hover {
            transform: scale(1.02);
            box-shadow: 0 8px 30px rgba(0, 0, 0, 0.1);
          }
        }
        
        code {
          background-color: #f3f4f6;
          padding: 3px 6px;
          border-radius: 4px;
          font-family: monospace;
          color: #d1365b;
          font-size: 14px;
        }
        
        pre {
          background-color: #1e293b;
          color: #e2e8f0;
          padding: 20px;
          border-radius: 8px;
          overflow-x: auto;
          margin: 20px 0;
          font-family: monospace;
          font-size: 14px;
          line-height: 1.5;
          position: relative;
          
          &::before {
            content: 'Código';
            position: absolute;
            top: 0;
            right: 0;
            background-color: rgba(255, 255, 255, 0.1);
            color: rgba(255, 255, 255, 0.7);
            padding: 2px 10px;
            font-size: 12px;
            border-radius: 0 8px 0 8px;
          }
        }
        
        table {
          width: 100%;
          border-collapse: collapse;
          margin: 20px 0;
          border-radius: 8px;
          overflow: hidden;
          box-shadow: 0 0 15px rgba(0, 0, 0, 0.05);
          
          th, td {
            border: 1px solid #e5e7eb;
            padding: 14px;
            text-align: left;
          }
          
          th {
            background-color: #f9fafb;
            font-weight: 600;
            color: #111827;
          }
          
          tr:nth-child(even) {
            background-color: #f9fafb;
          }
          
          tr {
            transition: background-color 0.2s ease;
            
            &:hover {
              background-color: #f0f4f9;
            }
          }
        }
        
        a {
          color: #0062cc;
          text-decoration: none;
          font-weight: 500;
          transition: all 0.2s ease;
          padding-bottom: 1px;
          border-bottom: 1px dashed transparent;
          
          &:hover {
            border-bottom-color: #0062cc;
          }
        }
        
        blockquote {
          border-left: 4px solid #0062cc;
          padding: 12px 20px;
          margin: 20px 0;
          color: #6b7280;
          font-style: italic;
          background-color: #f9fafb;
          border-radius: 0 8px 8px 0;
        }
      }
      
      .updates {
        .ant-timeline {
          margin-top: 10px;
          
          .ant-timeline-item {
            padding-bottom: 30px;
            
            h4 {
              font-weight: 600;
              margin: 0;
              display: flex;
              align-items: center;
              padding-bottom: 0;
              
              &::after {
                display: none;
              }
              
              .version {
                font-weight: 700;
                color: #0062cc;
                display: inline-block;
                padding: 3px 10px;
                background-color: rgba(0, 98, 204, 0.1);
                border-radius: 20px;
              }
              
              .date {
                font-size: 14px;
                color: #6b7280;
                margin-left: 10px;
              }
            }
            
            .update-content {
              margin-top: 12px;
              padding-top: 12px;
              border-top: 1px solid #eaedf0;
              line-height: 1.6;
            }
          }
        }
        
        .no-updates {
          padding: 40px;
          text-align: center;
          color: #6b7280;
          font-size: 16px;
          background-color: #f9fafb;
          border-radius: 8px;
        }
      }
    }
  }
`;

export const FullscreenButton = styled.button`
  position: absolute;
  top: 20px;
  right: 20px;
  width: 42px;
  height: 42px;
  background-color: rgba(255, 255, 255, 0.85);
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  z-index: 20;
  border: none;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.08);
  transition: all 0.2s ease;
  
  svg {
    color: #0062cc;
    font-size: 20px;
  }
  
  &:hover {
    background-color: rgba(255, 255, 255, 0.95);
    transform: scale(1.05);
    box-shadow: 0 4px 15px rgba(0, 0, 0, 0.12);
  }
  
  &:focus {
    outline: none;
  }
`;

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  background: white;
  border-radius: 16px;
  overflow: hidden;
  box-shadow: 0 8px 30px rgba(0, 0, 0, 0.06);
  transition: all 0.3s ease;
  height: 340px;
  width: 100%;
  margin: 0 auto;
  
  &:hover {
    transform: translateY(-5px);
    box-shadow: 0 12px 30px rgba(0, 0, 0, 0.1);
  }
  
  ${media.lessThan('medium')`
    height: 320px;
  `}
`;

export const ImageWrapper = styled.div`
  position: relative;
  width: 100%;
  height: 160px;
  background: linear-gradient(135deg, #f0f4f9 0%, #e6eef8 100%);
  display: flex;
  align-items: center;
  justify-content: center;
  overflow: hidden;
  
  img {
    width: 80px;
    height: 80px;
    object-fit: contain;
    filter: drop-shadow(0 4px 10px rgba(0, 0, 0, 0.15));
  }
`;

export const Content = styled.div`
  padding: 16px;
  display: flex;
  flex-direction: column;
  flex: 1;
`;

export const CategoryName = styled.div`
  color: #6b7280;
  font-size: 13px;
  font-weight: 500;
  margin-bottom: 8px;
  display: flex;
  align-items: center;
  
  .ant-tag {
    margin-left: 8px;
    font-size: 11px;
    padding: 0 6px;
    border: none;
    font-weight: 600;
    height: 20px;
    line-height: 20px;
  }
`;

export const Title = styled.h3`
  color: #111827;
  font-weight: 700;
  font-size: 17px;
  line-height: 1.3;
  margin-bottom: 10px;
  flex-grow: 0;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
  min-height: 44px;
`;

export const Price = styled.div`
  margin-bottom: 16px;
  display: flex;
  flex-direction: column;
  
  .current-price {
    font-size: 22px;
    font-weight: 700;
    color: #0062cc;
  }
  
  .old-price {
    font-size: 14px;
    color: #6b7280;
    text-decoration: line-through;
    margin-bottom: 2px;
  }
  
  .free-price {
    font-size: 18px;
    font-weight: 600;
    color: #10b981;
  }
`;

export const ButtonsContainer = styled.div`
  display: flex;
  align-items: center;
  margin-top: auto;
`;

export const ActionButton = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  padding: ${props => props.fullWidth ? '14px 24px' : '9px 16px'};
  border-radius: 10px;
  font-weight: 600;
  font-size: 14px;
  transition: all 0.2s ease;
  width: ${props => props.fullWidth ? '100%' : 'auto'};
  margin-right: ${props => props.secondary ? '0' : '8px'};
  
  background-color: ${props => {
    if (props.primary) return '#0062cc';
    if (props.secondary) return 'rgba(0, 98, 204, 0.08)';
    return 'transparent';
  }};
  
  color: ${props => {
    if (props.primary) return 'white';
    if (props.secondary) return '#0062cc';
    return '#6b7280';
  }};
  
  svg {
    font-size: ${props => props.secondary ? '22px' : '17px'};
    margin-right: ${props => props.secondary ? '0' : '6px'};
  }
  
  &:focus {
    outline: none;
  }
  
  ${media.lessThan('medium')`
    padding: ${props => props.fullWidth ? '12px 20px' : '8px 14px'};
    font-size: 13px;
  `}
`;

export const DetailsHeader = styled.div`
  display: flex;
  padding: 45px 40px;
  background: linear-gradient(135deg, #f0f4f9 0%, #e6eef8 100%);
  position: relative;
  transition: all 0.3s ease;
  
  &.fullscreen {
    padding: 50px 60px;
    
    img {
      width: 140px;
      height: 140px;
      margin-right: 50px;
    }
  }
  
  &::before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-image: radial-gradient(circle at 20% 30%, rgba(52, 84, 209, 0.08) 0%, transparent 40%),
                      radial-gradient(circle at 80% 60%, rgba(8, 145, 178, 0.07) 0%, transparent 30%);
  }
  
  img {
    width: 120px;
    height: 120px;
    object-fit: contain;
    margin-right: 35px;
    filter: drop-shadow(0 10px 20px rgba(0, 0, 0, 0.15));
    transition: all 0.3s ease;
    position: relative;
    z-index: 2;
    
    &:hover {
      transform: scale(1.05) rotate(2deg);
    }
  }
  
  ${media.lessThan('medium')`
    flex-direction: column;
    align-items: center;
    text-align: center;
    
    img {
      margin-right: 0;
      margin-bottom: 25px;
    }
    
    &.fullscreen {
      img {
        margin-right: 0;
      }
    }
  `}
`;

export const DetailsContent = styled.div`
  flex: 1;
  position: relative;
  z-index: 2;
  
  h3 {
    font-size: 28px;
    font-weight: 700;
    margin: 0 0 6px 0;
    display: flex;
    align-items: center;
    color: #111827;
    letter-spacing: -0.5px;
    line-height: 1.2;
    
    small {
      font-size: 14px;
      font-weight: 500;
      color: #6b7280;
      margin-left: 12px;
      background-color: rgba(107, 114, 128, 0.1);
      padding: 3px 10px;
      border-radius: 20px;
    }
    
    .share-icon {
      margin-left: 12px;
      font-size: 17px;
      cursor: pointer;
      color: #6b7280;
      transition: all 0.2s ease;
      padding: 6px;
      background: rgba(255, 255, 255, 0.5);
      border-radius: 50%;
      
      &:hover {
        color: #0062cc;
        transform: scale(1.1);
        background: rgba(255, 255, 255, 0.9);
      }
    }
  }
  
  h5 {
    font-size: 16px;
    font-weight: 500;
    color: #6b7280;
    margin: 0 0 20px 0;
    display: flex;
    align-items: center;
    
    &::before {
      content: '';
      display: inline-block;
      width: 8px;
      height: 8px;
      background-color: #0062cc;
      border-radius: 50%;
      margin-right: 8px;
    }
  }
  
  .plugin-price {
    font-size: 26px;
    font-weight: 700;
    color: #0062cc;
    margin: 0 0 24px 0;
    display: flex;
    align-items: center;
    
    small {
      font-size: 16px;
      font-weight: 500;
      color: #6b7280;
      text-decoration: line-through;
      margin-left: 12px;
    }
  }
  
  .plugin-stats {
    display: flex;
    align-items: center;
    color: #6b7280;
    margin-top: 20px;
    font-size: 14px;
    background: rgba(255, 255, 255, 0.7);
    padding: 8px 14px;
    border-radius: 8px;
    display: inline-flex;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.05);
    
    svg {
      color: #f59e0b;
      margin-right: 6px;
    }
    
    span {
      font-weight: 600;
      margin-right: 5px;
      color: #111827;
    }
  }
  
  ${media.lessThan('medium')`
    width: 100%;
    
    h3 {
      justify-content: center;
    }
    
    h5 {
      justify-content: center;
    }
    
    .plugin-price {
      justify-content: center;
    }
  `}
`;
